module.exports = __webpack_public_path__ + "static/media/fmi-logo-white.dc97f73a.svg";